import { Option } from 'react-multi-select-component';

const escapeRegExp = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const handleDepartmentChange = (
  selectedOptions: Option[],
  currentValues: string[],
  departmentsList: Option[]
): string[] => {
  if (!selectedOptions || selectedOptions.length === 0) {
    return [];
  }

  const selectedIds = new Set<string>(
    selectedOptions.map((opt) => String(opt.value)).filter(Boolean)
  );
  const prevIds = new Set<string>((currentValues || []).map(String));

  // 1. Dynamically identify all Core Departments (standalone departments without '-' or '(')
  const coreDepartmentOpts = departmentsList.filter((opt) => {
    if (!opt?.label) return false;
    const name = opt.label.trim();
    return !name.includes('-') && !name.includes('(') && !name.includes(')');
  });

  // 2. Dynamically link sub-departments to their core department(s)
  for (const deptOpt of departmentsList) {
    if (!deptOpt?.label || deptOpt?.value == null) continue;
    const deptId = String(deptOpt.value);
    const deptLabelUpper = deptOpt.label.toUpperCase().trim();

    // Find all core departments referenced inside this sub-department's label
    const matchingCoreOpts = coreDepartmentOpts.filter((coreOpt) => {
      const coreNameUpper = coreOpt.label.toUpperCase().trim();
      if (coreNameUpper === deptLabelUpper) return false;

      // Special handling for M&P acronym (maps to Mechanical and Plumbing)
      if (deptLabelUpper.includes('M&P')) {
        return coreNameUpper === 'MECHANICAL' || coreNameUpper === 'PLUMBING' || coreNameUpper === 'PLUMB';
      }

      // Safe word-boundary check matching core department name without syntax errors
      const safeCoreName = escapeRegExp(coreNameUpper);
      const regex = new RegExp(`(?:^|[^A-Z0-9])${safeCoreName}(?:$|[^A-Z0-9])`, 'i');
      return regex.test(deptLabelUpper);
    });

    for (const coreOpt of matchingCoreOpts) {
      const coreId = String(coreOpt.value);

      const isSubSelectedNow = selectedIds.has(deptId);
      const wasSubSelectedBefore = prevIds.has(deptId);
      const wasCoreSelectedBefore = prevIds.has(coreId);

      // Rule 1: Auto-select core department when sub-department is selected
      if (isSubSelectedNow) {
        selectedIds.add(coreId);
      }
      // Rule 2: Preserve core department when sub-department is deselected
      if (wasSubSelectedBefore && !isSubSelectedNow && wasCoreSelectedBefore) {
        selectedIds.add(coreId);
      }
    }
  }

  return Array.from(selectedIds);
};
